export default defineNuxtPlugin({
    name: 'app-translation-override',
    enforce: 'post', // run after i18n
    setup(nuxtApp) {
        const { vueApp } = nuxtApp;
        const snippetSet = ref<Record<string, string>>({});

        const interpolate = (template: string, values?: any) => {
            if (!values || typeof values !== 'object') return template;
            return template.replace(/\{(\w+)\}/g, (match, key) => {
                return values[key] !== undefined ? String(values[key]) : match;
            });
        };

        // Fetch snippets non-blocking
        const loadSnippets = async () => {
            try {
                const i18n = nuxtApp.$i18n as any;
                const currentLocale = i18n?.locale?.value || 'de-DE';
                const data = await $fetch<any>(`/api/snippets/${currentLocale}`);
                if (data && data.snippets && typeof data.snippets === 'object') {
                    snippetSet.value = data.snippets;
                }
            } catch (e) {
                console.error('Failed to load snippets in appTranslation plugin', e);
            }
        };

        if (process.client || import.meta.server) {
            loadSnippets();
        }

        // Wait until vue-i18n finishes its installation (which is usually fast/sync)
        // We can hook into app:created to ensure we modify globalProperties after i18n
        nuxtApp.hook('app:created', (app) => {
            const originalT = app.config.globalProperties.$t;
            if (!originalT) {
                // Fallback if original $t is not found for some reason
                const i18n = nuxtApp.$i18n as any;
                const fallbackT = i18n ? i18n.t : (key: string) => key;
                app.config.globalProperties.$t = (key: string, ...args: any[]) => {
                    if (snippetSet.value[key] !== undefined && snippetSet.value[key] !== null) {
                        return interpolate(snippetSet.value[key], args[0]);
                    }
                    return (fallbackT as any)(key, ...args);
                };
                return;
            }

            app.config.globalProperties.$t = (key: string, ...args: any[]) => {
                if (snippetSet.value[key] !== undefined && snippetSet.value[key] !== null) {
                    return interpolate(snippetSet.value[key], args[0]);
                }
                return (originalT as any)(key, ...args);
            };
        });
    }
});
